import React, { useRef, useEffect } from "react";
import { Chart } from "chart.js/auto";

function Profile({ total, easy, medium, hard }) {
  const chartRef = useRef(null);

  useEffect(() => {
    const ctx = chartRef.current.getContext("2d");

    if (chartRef.current.chartInstance) {
      chartRef.current.chartInstance.destroy();
    }

    const chartInstance = new Chart(ctx, {
      type: 'pie',
      data: {
        labels: ['Easy', 'Medium', 'Hard'],
        datasets: [{
          data: [easy || 20, medium || 40, hard || 60],
          backgroundColor: ['#4CAF50', '#FFC107', '#F44336'],
          hoverOffset: 10
        }]
      },
      options: {
        responsive: true,
        animation: {
          animateRotate: true,
          animateScale: true
        }
      }
    });

    chartRef.current.chartInstance = chartInstance;

    return () => {
      chartInstance.destroy();
    };
  }, [easy, medium, hard]);

  return (
    <div className="">
      <canvas ref={chartRef} id="progressChart" className="mr-1 w-64 h-64 mt-0 text-blue-400"></canvas>
    </div>
    // <>
    // <h1 className="text-purple-500">Profile</h1>
    // </>
  );
}

export default Profile;
